module.exports = __webpack_public_path__ + "static/img/abimg7.2b84996.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/abimg7.png
// module id = efdl
// module chunks = 1